
var VKLogin = function() {
	
	var __vkURL = "//vk.com/js/api/openapi.js";
	var __isLoaded = false;
	var __type = 0; /* login = 1, register = 2 */

	this.vkLoginClick = function (){

		vkLogin();
		
	}
	
	this.vkRegisterClick = function (){
		
		vkLogin();
		
	}

	this.init = function(apiId, type) {	

		console.log("vkInit:" + apiId + "|" + type);
		try {

			var t = document.createElement("script");
			t.async = true;
			t.src = __vkURL;

			if (t.readyState) {
				t.onreadystatechange = function() {
					if (this.readyState == "complete"
							|| this.readyState == "loaded") {
						t.onreadystatechange = null;
						__isLoaded = true;
						initVK(apiId, type);
					}
				}
			} else {
				t.onload = function() {
					__isLoaded = true;
					initVK(apiId, type);
				}
			}
			document.body.appendChild(t); 
			
			setTimeout(function(){ 
				if(!__isLoaded){
					var url = URL_MAPPING.resolveUrl('/common/error');
					$.post(url, { userAgent : window.navigator.userAgent, msg: "VK load error." });
					console.log("vkInit ERROR " + apiId + "|load");
				} else {
					console.log("vkInit LOADED " + apiId);
				}
					
			}, 5000);
			
		} catch (e) {
			var url = URL_MAPPING.resolveUrl('/common/error');
			$.post(url, { userAgent : window.navigator.userAgent, msg: "VK init error." });
			console.log("vkInit ERROR " + apiId + "|" + e);
		}

	}
	
	function initVK(apiId, type){
		
		__type = type;
		
		if(window['VK']){
			
			VK.init({
				 apiId: apiId 
			});

		} else {
			var url = URL_MAPPING.resolveUrl('/common/error');
			$.post(url, { userAgent : window.navigator.userAgent, msg: "VK is not defined." });
			console.log("initVK ERROR " + apiId + "|VK is not defined.");
		}

	}
	
	function vkLogin(){
		
		VK.Auth.login(function(response) {
			
			if(response.status === "connected"){
				
				VK.Api.call("users.get",{user_id:response.session.user.id,fields: "sex,bdate,city"},function(response){
					
					var oldResponse = response;
					
					VK.Api.call("places.getCityById",{city_ids:response.response[0].city},function(response){
										
						var gender = oldResponse.response[0].sex == 1 ? 2 : 1;

						if(__type == 1)
							loginSocialNetworkUser(oldResponse.response[0].uid,"vkontakte","",oldResponse.response[0].first_name,oldResponse.response[0].last_name,gender,oldResponse.response[0].bdate,null);
						else if (__type == 2)
							loginSocialNetworkUser(oldResponse.response[0].uid, "vkontakte","",oldResponse.response[0].first_name,oldResponse.response[0].last_name,gender,oldResponse.response[0].bdate,null);
						
					});
					
				});				
				
			}
			
		});
	
	}

	return {
		init : init,
		vkLoginClick : vkLoginClick,
		vkRegisterClick : vkRegisterClick
	}

}();